module.exports = {"nav":{"home":"首页","game":"游戏中心","services":"客服支持","joinus":"招聘信息","joinus_campus":"校园招聘","joinus_socail":"社会招聘","aboutus":"关于我们","language":"语言","language_zh":"中文","language_en":"英文"},"home":{"bole_we":"博乐的我们","join_we":"加入博乐科技","wait_you":"我们随时欢迎您的光临！","msg":"在此输入您的电子邮箱"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/zh.json
// module id = FXFJ
// module chunks = 1